import { AxiosPromise } from 'axios';
import { IGetClassroom, IGetClassrooms, IClassroomReq } from '../models/classrooms.model';
import axios from 'axios';

const uri = '/mgmt/classrooms';

export const getClassroom = (id: string): AxiosPromise<IGetClassroom> => {
  return axios.get(`${uri}/campus/${id}`);
}

export const getClassrooms = (): AxiosPromise<IGetClassrooms> => {
  return axios.get(uri);
}

export const getCampusClassrooms = (campusCode: string): AxiosPromise<IGetClassrooms> => {
  return axios.get(`${uri}/${campusCode}`);
}

export const createClassroom = (campusCode: string, data: IClassroomReq): AxiosPromise => {
  return axios.post(`${uri}/${campusCode}`, data);
};

export const updateClassroom = (classroomCode: string, data: IClassroomReq): AxiosPromise => {
  return axios.put(`${uri}/campus/${classroomCode}`, data);
};

export const deleteClassroom = (id: string): AxiosPromise => {
  return axios.delete(`${uri}/campus/${id}`);
};
